import { render, staticRenderFns } from "./WebCamera.vue?vue&type=template&id=28b9691c&scoped=true"
import script from "./WebCamera.vue?vue&type=script&lang=js"
export * from "./WebCamera.vue?vue&type=script&lang=js"
import style0 from "./WebCamera.vue?vue&type=style&index=0&id=28b9691c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b9691c",
  null
  
)

export default component.exports